export default __webpack_public_path__ + "static/media/preview.71b3c897.png";